module.exports = __webpack_public_path__ + "banquet/components/images/trashcan.a2ab08aff2ecf8f6f42eace600947c58.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/trashcan.svg
// module id = 1046
// module chunks = 1